import { FEATURES } from '../config/featureFlags';
import { isPaddleCheckoutConfigured } from './paddleCheckout';

/**
 * Paddle overlay (VITE_*): indica si el flujo de checkout técnico puede inicializarse.
 * No usar para permisos de usuario — eso es solo {@link canOperateBilling}.
 */
export function isPaddleCheckoutFlowConfigured() {
  return FEATURES.FEATURE_PADDLE_CHECKOUT_V1 === true && isPaddleCheckoutConfigured();
}

/**
 * Operaciones de billing (checkout Paddle, portal, upgrade API) permitidas para este usuario.
 * Fuente de verdad única: `billing_operations_allowed === true` en GET /api/plan/summary.php.
 * @param {{ billing_operations_allowed?: boolean } | null | undefined} planStatus
 * @returns {boolean}
 */
export function canOperateBilling(planStatus) {
  return planStatus?.billing_operations_allowed === true;
}

export function showPaymentsDisabledModal({ showModal, closeModal, t }) {
  if (typeof showModal !== 'function') return;
  showModal({
    title: t('plans.payments_disabled.title'),
    message: t('plans.payments_disabled.message'),
    confirmText: t('plans.payments_disabled.confirm'),
    onConfirm: () => {
      if (typeof closeModal === 'function') closeModal();
    },
  });
}
